export const daysBack = 7;
export const dispersionThreshold = 0.15;
export const growthThreshold = 0.2;
export const minimumPriceTargets = 3;
